import Language from './enums/Language'
import DayKey from './types/DayKey'

// FIXME: Refactor to enum.
export const THEMES = {
  DEFAULT: 'default',
  DARK: 'dark',
  LIGHT: 'light',
  BLUE: 'blue',
  GREEN: 'green',
  INDIGO: 'indigo'
}

export const DEFAULT_THEME = THEMES.DARK

export const DEFAULT_LANGUAGE = Language.ENGLISH_US

/**
 * Mappings of all languages to their names and icons.
 */
export const LANGUAGES: Readonly<Record<Language, { icon: string; name: string }>> = Object.freeze({
  fi: {
    icon: '/static/img/flags/fi.png',
    name: 'Suomi'
  },
  en: {
    icon: '/static/img/flags/us.png',
    name: 'English'
  },
  swe: {
    icon: '/static/img/flags/se.png',
    name: 'Svenska'
  },
  de: {
    icon: '/static/img/flags/de.png',
    name: 'Deutsch'
  },
  no: {
    icon: '/static/img/flags/no.png',
    name: 'Norsk (Bokmål)'
  },
  fr: {
    icon: '/static/img/flags/fr.png',
    name: 'Français'
  },
  nl: {
    icon: '/static/img/flags/nl.png',
    name: 'Nederlands'
  },
  es: {
    icon: '/static/img/flags/es.png',
    name: 'Español'
  }
})

export const TRANSLATION_NAMESPACES = [
  'actionRequest',
  'automation',
  'actions',
  'alert',
  'asset',
  'aurora',
  'breadcrumbs',
  'catalogProduct',
  'common',
  'graph',
  'generator',
  'device',
  'heater',
  'installation',
  'manufacturing',
  'powerSupply',
  'ruuvitag',
  'sms',
  'sensor',
  'validation',
  'valve'
] as const

export const DAYS_OF_THE_WEEK: DayKey[] = [0, 1, 2, 3, 4, 5, 6] as const

export const DEFAULT_TIMEZONE = 'Europe/Helsinki' as const
